import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const COLS = [
  { key: "New", title: "New Orders" },
  { key: "Accepted", title: "Accepted" },
  { key: "Cooking", title: "Cooking" },
  { key: "Ready", title: "Ready" },
];

export default function Kitchen() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/kitchen/queue").then(({data}) => setOrders(data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, []);
  const move = async (oid, status) => {
    await api.patch(`/orders/${oid}/kitchen`, { status });
    toast.success(`Marked ${status}`);
    load();
  };
  return (
    <div data-testid="kitchen-page">
      <h1 className="font-heading text-3xl text-[#FAF9F6] mb-6">Kitchen Display</h1>
      <div className="grid md:grid-cols-4 gap-4">
        {COLS.map((col) => {
          const list = orders.filter((o) => (o.kitchen_status || "New") === col.key);
          return (
            <div key={col.key} className="admin-card p-4">
              <h3 className="font-accent text-xs uppercase tracking-wider text-[#D4AF37] mb-3">{col.title} <span className="ml-1 text-[#FAF9F6]/60">({list.length})</span></h3>
              <div className="space-y-3">
                {list.map((o) => (
                  <div key={o.id} className="bg-[#0B0E14] border border-[#D4AF37]/15 rounded p-3" data-testid={`kitchen-${o.id}`}>
                    <div className="flex justify-between text-xs">
                      <span className="font-accent text-[#D4AF37]">{o.order_number}</span>
                      <span className="text-[#FAF9F6]/40">{new Date(o.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                    </div>
                    <div className="text-sm text-[#FAF9F6]/90 my-2 font-heading">{o.customer_name}</div>
                    <ul className="text-xs text-[#FAF9F6]/70 space-y-0.5 mb-3">
                      {o.items.filter(i => i.item_type !== "grocery").map((i, idx) => (
                        <li key={idx}>{i.quantity}× {i.name}</li>
                      ))}
                    </ul>
                    {o.notes && <div className="text-[10px] text-[#E8A87C] italic mb-2">"{o.notes}"</div>}
                    <div className="flex gap-1">
                      {col.key === "New" && <button data-testid={`kitchen-accept-${o.id}`} onClick={() => move(o.id, "Accepted")} className="flex-1 text-xs bg-[#D4AF37] text-[#050505] py-1.5 rounded">Accept</button>}
                      {col.key === "Accepted" && <button data-testid={`kitchen-cook-${o.id}`} onClick={() => move(o.id, "Cooking")} className="flex-1 text-xs bg-[#D4AF37] text-[#050505] py-1.5 rounded">Start Cooking</button>}
                      {col.key === "Cooking" && <button data-testid={`kitchen-ready-${o.id}`} onClick={() => move(o.id, "Ready")} className="flex-1 text-xs bg-[#2C4A3B] text-white py-1.5 rounded">Mark Ready</button>}
                      {col.key === "Ready" && <button data-testid={`kitchen-done-${o.id}`} onClick={() => move(o.id, "Served")} className="flex-1 text-xs bg-[#0F3D81] text-[#D4AF37] py-1.5 rounded">Served</button>}
                    </div>
                  </div>
                ))}
                {list.length === 0 && <div className="text-xs text-[#FAF9F6]/30 text-center py-6">Empty</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
